export type DateInput = Date | string | number | null | undefined;

export function toValidDate(value: DateInput): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateSafe(
  value: DateInput,
  options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' },
  fallback: string = '-',
): string {
  const d = toValidDate(value);
  return d ? new Intl.DateTimeFormat('pt-BR', options).format(d) : fallback;
}
